import EmailAlertsTextTooltipContent from './EmailAlertsTextTooltipContent';

export default EmailAlertsTextTooltipContent;
